"use strict";
//See the readme markdown file for additional details.
var connections;
(function (connections) {
    var domainselector;
    (function (domainselector) {
        var DomainSelectorComponentController = /** @class */ (function () {
            function DomainSelectorComponentController($scope) {
                var _this = this;
                this.$scope = $scope;
                this.disableSearch = false; //disable search if received data has only one option
                this.searchEmpty = false; //to show error message for empty filterd list
                this.selectedOption = ''; //model value for the search input
                this.showList = false; //to show/hide list
                //#region Public Methods
                //Enter event on the dropdown option sets the output
                this.selectOnEnterKey = function ($event, index) {
                    if (_this.isEnterKey($event)) {
                        _this.selectOneOption(index);
                    }
                    return true;
                };
                //Change event that filters the dropdown options as per the user search.
                this.filterOptions = function (option) {
                    _this.filteredData = option ? _this.unfilteredData.filter(function (item) { return item.toLowerCase().indexOf(option.toLowerCase()) >= 0; }) : _this.unfilteredData;
                    //Flag to show/hide message if the user searched options are available or not in the dropdown list.
                    _this.searchEmpty = _this.filteredData.length ? false : true;
                    _this.showList = true;
                };
                //Enter event on search bar to show dropdown options
                //For accessiblity we need to show all the dropdown options if the user enters on search bar, or else if the user 
                //starts searching, even though the dropdown will open ,but the users may only see the filtered list.
                this.openListOnEnter = function ($event) {
                    if (_this.isEnterKey($event)) {
                        _this.showList = true;
                    }
                };
                //Click event to set the search model's value to user selected option from the dropdown.
                this.selectOneOption = function (index) {
                    //Only if the current selected option is not the same as the previously selected option,
                    //we throw an emit event containing selected domain option as its payload.
                    //This event can be captured in SPA to perform any actions on selected domain.
                    if (_this.selectedOption !== _this.filteredData[index]) {
                        _this.selectedOption = _this.filteredData[index];
                        _this.$scope.$emit(domainselector.Event.DomainSelectionSuccess.toString(), { selectedDomain: _this.selectedOption });
                    }
                    _this.showList = false;
                };
                //#endregion
                //#region Private Methods
                this.isEnterKey = function ($event) {
                    var keyCode = $event.which || $event.keyCode;
                    return keyCode === 13;
                };
                //Initialzing the data for the dropdown to display(filteredData) and also
                //unfilteredData(original copy) to the data received from parent controller.
                this.filteredData = this.unfilteredData = this.data;
                //Setting the default dropdown option to the domainId selected by the user.
                //If the defaultId is empty, no option is pre-selected.
                if (this.defaultId) {
                    this.filterOptions(this.defaultId);
                    this.selectOneOption(0);
                    //Again Initialzing to the original data, to show all domains options.
                    this.filteredData = this.unfilteredData = this.data;
                }
                //If the length of received data is one, then setting the only option as defaultId option in dropdown.
                //Also if the length of data is one or zero, the search is disabled
                if (this.filteredData.length <= 1) {
                    this.disableSearch = true;
                    this.selectOneOption(0);
                }
            }
            DomainSelectorComponentController.$inject = ['$scope'];
            return DomainSelectorComponentController;
        }());
        var DomainSelectorComponent = /** @class */ (function () {
            function DomainSelectorComponent() {
                this.bindings = {
                    data: '<',
                    defaultId: '<' // Using one-way binding to get default domainId from SPA, to preselect the dropdown option.
                };
                this.controller = DomainSelectorComponentController;
                this.templateUrl = '/node_modules/@connections-education/domain-selector/dist/connections.domainselector.html';
            }
            return DomainSelectorComponent;
        }());
        angular
            .module('connections.domainselector')
            .component('cxDomainSelector', new DomainSelectorComponent());
    })(domainselector = connections.domainselector || (connections.domainselector = {}));
})(connections || (connections = {}));

//# sourceMappingURL=connections.domainselector.js.map
